import { Paper, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export default function SearchNotFound({ searchQuery = '', ...other }) {
  const { t } = useTranslation();
  return searchQuery ? (
    <Paper {...other}>
      <Typography gutterBottom align="center" variant="subtitle1">
        {t('chat.search_not_found_title')}
      </Typography>
      <Typography variant="body2" align="center">
        {t('chat.search_not_found_description')}{' '}
        <strong>&quot;{searchQuery}&quot;</strong>.
      </Typography>
    </Paper>
  ) : (
    <Typography variant="body2">{t('chat.search_enter_keywords')}</Typography>
  );
}
